<div class="flex items-start gap-8 p-4">
  <div class="flex w-96 flex-col justify-center gap-4">
    <div class="flex flex-col items-center">
      <img class="w-48" src="/assets/icons/principle-row-dark.png" />
      <mat-icon class="compare-arrow">compare_arrows</mat-icon>
      <img class="w-52" src="/assets/integrations/parchment-logo.png" />
      <h2 class="!mb-0 pt-4">ePrescription Integration</h2>
    </div>

    <div>
      Simple, clinic-based ePrescriptions for Australian Dentists. Sync patients
      from Principle and write compliant, electronic/paper prescriptions from
      your computer or phone, all visible within Principle.
    </div>

    <a
      class="flex-1"
      target="_blank"
      mat-stroked-button
      [href]="parchmentLandingPageUrl"
    >
      <span>Learn More</span>
      <mat-icon>open_in_new</mat-icon>
    </a>
  </div>
</div>
